import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigurationContext } from '../../ContextProviders/ConfigurationProvider';
import useConfigurationChanges from '../../Hooks/useConfigurationChanges';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const StyledTypography = withStyles((theme) => ({
  root: {
    marginTop: 16,
    marginBottom: 8,
    maxWidth: 400,
    color: theme.palette.primary.main,
  },
}))(Typography);

export const MenuHint = ({ componentIdentifier, component = 'div', ...props }) => {
  const { t } = useTranslation();
  const configuration = useContext(ConfigurationContext);
  const { itemIdentifier } = useConfigurationChanges(configuration);
  const hintText = t(`hints.${itemIdentifier}.${componentIdentifier}`, '');
  return !hintText ? null : (
    <StyledTypography component={component} {...props}>
      {hintText}
    </StyledTypography>
  );
};

MenuHint.propTypes = {
  componentIdentifier: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
};

export default MenuHint;
